import Vue from 'vue'
import App from '@/app'
import { sync } from 'vuex-router-sync'
import router from '@/router'
import store from '@/store/store'
import './filters'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pl'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
  // use sentry only on production
  Sentry.init({
    dsn: 'https://eb52be4be912490ba2934efce5e625c5@sentry.io/1885659',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    environment: 'live'
  })
}

Vue.use(ElementUI, { locale })

sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  strict: true
})



// WEBPACK FOOTER //
// ./src/main.js